export const Footer = () => {
return (
<div className="w-full h-12 md:h-14 flex shadow-sm mt-10  bg-[#71c16a] pt-2 pb-3 justify-between items-center">
    <div className="w-11/12 mx-auto"><p className="text-white tracking-wider text-[0.75em] md:text-[0.9em] font-[300]">Made by Emma Sargeant 2023</p></div>
</div>)}